import React from "react";
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import RoutesList from "../constants/RoutesList";
import Construction from "../views/others/Construction";
import CoursesProvider from "../context/CoursesContext";
import HeadersProvider from "../context/HeadersContext";
import AcademyProvider from "../context/DomecqContext";
import FacilitatorsProvider from "../context/FacilitatorsContext";
import HomeProvider from "../context/HomeContext";

export default function Routes() {
   return (
      <HomeProvider>
         <AcademyProvider>
            <HeadersProvider>
               <CoursesProvider>
                  <FacilitatorsProvider>
                     <Switch>
                        {RoutesList.map((item, index) => (
                           <Route exact={item.exact} path={item.path} key={index}>
                              <item.component />
                           </Route>
                        ))}
                        <Route component={Construction} />
                     </Switch>
                  </FacilitatorsProvider>
               </CoursesProvider>
            </HeadersProvider>
         </AcademyProvider>
      </HomeProvider>
   );
}
